import React, { useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { NarrativeSection } from './components/NarrativeSection';
import { LawsSection } from './components/LawsSection';
import { ProductReveal } from './components/ProductReveal';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { FloatingCTA } from './components/FloatingCTA';
import { FooterLegal } from './components/FooterLegal';
export function App() {
  const [isOrderBumpChecked, setIsOrderBumpChecked] = useState(false);
  return <main className="bg-[#050505] min-h-screen w-full selection:bg-[#d4af37] selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <NarrativeSection data-id="element-2" />
      <LawsSection data-id="element-3" />
      <ProductReveal data-id="element-4" />
      <BonusesSection data-id="element-5" />
      <OfferSection isOrderBumpChecked={isOrderBumpChecked} onOrderBumpToggle={() => setIsOrderBumpChecked(!isOrderBumpChecked)} data-id="element-6" />
      <FloatingCTA isOrderBumpChecked={isOrderBumpChecked} data-id="element-7" />
      <FooterLegal data-id="element-8" />
    </main>;
}